import { Icon } from "@/components/Icon";
import {
  Root,
  Item as PrimitiveItem,
  Header,
  Trigger as PrimitiveTrigger,
  Content as PrimitiveContent,
} from "@radix-ui/react-accordion";
import { FC, PropsWithChildren } from "react";
import { createSlots } from "utils/create-slots";

const Accordion: FC<
  PropsWithChildren<{
    type?: "multiple";
    className?: string;
    defaultValue?: string[];
  }>
> = ({ children, type = "multiple", className = "", defaultValue }) => {
  return (
    <Root type={type} className={className} defaultValue={defaultValue}>
      {children}
    </Root>
  );
};

const Item = ({ children, value, className = "" }) => {
  const [title, content] = createSlots(["title", "content"], children);
  return (
    <PrimitiveItem className={className} value={value}>
      <Header>{title}</Header>
      {content}
    </PrimitiveItem>
  );
};
const Trigger = ({ children }) => (
  <PrimitiveTrigger className="flex  w-full justify-between group items-center">
    {children}
    <Icon
      type="chevron"
      purposeLabel="Akkordeon öffnen"
      className=" w-[24px] ml-auto xl:hidden text-blue-light rotate-90 group-open:-rotate-90"
    />
  </PrimitiveTrigger>
);

const Content = ({ children }) => (
  <PrimitiveContent forceMount={true} className="closed:hidden xl:!block">
    {children}
  </PrimitiveContent>
);

export default Object.assign(Accordion, { Trigger, Content, Item });
